<template>
  <div>
    <!-- View/Edit popup -->
    <vs-popup class="extended-popup" title="" :active.sync="resellerPopupActive">
      <div class="vs-con-loading__container indented-section" id="regDiv-with-loading">
        <div class="mx-auto mt-5 inner-indented-section view-edit-partner-form">
          <!-- Heading -->
          <div class="vx-row flex-wrap title-bar">
            <h3>{{ resellerModalHeading }}</h3>
          </div>

          <hr>

          <vs-tabs class="mt-2 add-partner-tabs">
            <vs-tab label="Registrar & Reseller Details">
              <hr class="mt-2">

              <div class="tab-text">
                <div class="vx-row mt-8">
                  <div class="vx-col">
                    <h5 class="tab-title">Registrar Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4" v-for="(regDetail, index) in formDataReseller['registrarDetails']" :key="`ParentReg-${index}`">
                    <label class="vs-input--label inline-flex pb-2">Parent Registrar {{ index == 0 ? '*' : ''}}</label>
                      <v-select
                        :data-vv-name="`Parent Registrar-`+index"
                        class="w-full"
                        :class="errors.has(`Parent Registrar-`+index) ? 'select-required-error' : ''"
                        v-model="regDetail.parentRegistrar"
                        :options="formCustomUniqueRegs"
                        :closeOnSelect="true"
                        :clearable="false"
                        v-validate="!index ? 'required' : ''"
                        data-vv-validate-on="change"
                        :required="!regDetail.parentRegistrar"
                        @input="setAllToView()"
                        :noDrop="(mode == 'view' && reqType == 'edit-req') || (!reqType)"></v-select>
                    <vs-button size="small" color="black" class="mt-2" :type="`${regDetail['viewDetails'] ? 'filled' : 'border'}`" @click="toggleViewDetails(index)">{{ regDetail['viewDetails'] ? 'View Details' : 'Hide Details'}}</vs-button>
                  </div>
                </div>

                <div v-if="showRegDetails">
                  <div class="vx-row mt-4">
                    <div class="vx-col w-1/4">
                      <label class="vs-input--label inline-flex pb-2">Account Manager</label>
                      <vs-input
                        class="w-full"
                        name="Reg Account Manager"
                        v-bind:readonly="true"
                        v-model="formDataReseller['registrarDetails'][regDetailsIndex]['accountManager']" />
                    </div>

                    <div class="vx-col w-1/4">
                      <label class="vs-input--label inline-flex pb-2">Country</label>
                      <vs-input
                        class="w-full"
                        name="Reg Country"
                        v-bind:readonly="true"
                        v-model="formDataReseller['registrarDetails'][regDetailsIndex]['country']" />
                    </div>

                    <div class="vx-col w-1/2 px-0" v-for="(id, index) in formDataReseller['registrarDetails'][regDetailsIndex]['cnicIanaIDs']" :key="`CNICIANA-${index}`" :class="index ? 'mt-1' : ''">
                      <div class="vx-row px-0">
                        <div class="vx-col w-1/2">
                          <label class="vs-input--label inline-flex pb-2">IANA ID</label>
                          <vs-input
                            class="w-full"
                            name="IANA ID"
                            v-bind:readonly="true"
                            v-model="id['iana_id']" />
                        </div>

                        <div class="vx-col w-1/2">
                          <label class="vs-input--label inline-flex pb-2">CNIC ID</label>
                          <vs-input
                            class="w-full"
                            name="CNIC ID"
                            v-bind:readonly="true"
                            v-model="id['cnic_id']" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <hr class="my-8">

                <div class="vx-row mt-6">
                  <div class="vx-col">
                    <h5 class="tab-title">Reseller Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Short Name *</label>
                    <!-- TODO: Character count error precedence over required error -->
                    <!-- NOTE: Backup regex if later special characters aren't allowed: v-validate="{ required: true, max:50, regex: /^[a-zA-Z0-9]+(?:[ ]?[a-zA-Z0-9]+)*$/ }" -->
                    <vs-input
                      class="w-full"
                      name="Reseller Short Name"
                      v-model="formDataReseller['resellerDetails']['resellerShortName']" 
                      v-validate="{ required: true, max:50 }"
                      data-vv-validate-on="change"
                      :danger="errors.has('Reseller Short Name') || (formDataReseller['resellerDetails']['resellerShortName'] ? formDataReseller['resellerDetails']['resellerShortName'].length : 0) > 50"
                      :danger-text="errors.has('Reseller Short Name') ? (errors.items.find(x => x.field == 'Reseller Short Name').rule == 'required' ? 'Required field' : errors.items.find(x => x.field == 'Reseller Short Name').msg) : characterCount"
                      v-bind:readonly="(mode == 'view' && !reqType)"/>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Account Manager</label>
                      <v-select
                        name="Reseller Account Manager"
                        class="w-full"
                        v-model="formDataReseller['resellerDetails']['accountManager']"
                        :options="formAMs"
                        :closeOnSelect="true"
                        :clearable="false"
                        :noDrop="!reqType || reqType == 'edit-req'"></v-select>
                  </div>

                  <div class="vx-col w-1/4" v-if="!((mode == 'view' && !reqType))">
                    <label class="vs-input--label inline-flex pb-2">New Account Manager</label>
                      <v-select
                        name="Reseller New Account Manager"
                        class="w-full"
                        v-model="formDataReseller['resellerDetails']['newAccountManager']"
                        :options="formAMs"
                        :closeOnSelect="true"
                        :clearable="false"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Start Date {{ (formDataReseller['resellerDetails']['accountManager'] !== formDataReseller['resellerDetails']['newAccountManager']) ? '*' : ''}}</label>
                    <flat-pickr
                      class="w-full"
                      name="Start date"
                      :config="configDateTimePicker"
                      v-model="formDataReseller['resellerDetails']['startDate']"
                      v-validate="{ required: !((mode == 'view' && !reqType)) && (formDataReseller['resellerDetails']['accountManager'] !== formDataReseller['resellerDetails']['newAccountManager'])}"
                      :required="!((mode == 'view' && !reqType)) && (formDataReseller['resellerDetails']['accountManager'] !== formDataReseller['resellerDetails']['newAccountManager'])"
                      data-vv-validate-on="change"
                      placeholder="YYYY-MM-DD"
                      :readonly="mode === 'view'"/>
                      <span v-if="errors.has('Start Date')" class="select-required-error--span span-text-validation"> Required field </span>
                  </div>
                </div>

                <!-- TODO: Fix height for when selected options > 1 -->
                <div class="vx-row mt-4">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Country</label>
                    <v-select
                        name="Reseller Country"
                        class="w-full"
                        v-model="formDataReseller['resellerDetails']['country']"
                        :options="formGeo"
                        :closeOnSelect="true"
                        :clearable="false"
                        :noDrop="(mode == 'view' && !reqType)"></v-select>
                  </div>
                  
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Website</label>
                    <vs-input
                      class="w-full"
                      name="Reseller Website"
                      v-model="formDataReseller['resellerDetails']['website']" 
                      v-validate="'url'"
                      data-vv-validate-on="change"
                      :danger="formDataReseller['resellerDetails']['website'] ? errors.has('Reseller Website') : false"
                      :danger-text="'Invalid URL'"
                      v-bind:readonly="(mode == 'view' && !reqType)"/>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label pb-2 flex justify-between">
                      <span>Group Entity *</span>
                      <span class="mr-0">
                        <vx-tooltip text="The parent group this partner belongs to" position="top" class="tooltip-in-popup">
                            <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null"></i>
                        </vx-tooltip>
                      </span>
                    </label>
                    <v-select
                    name="Group Entity"
                    class="w-full"
                    :class="errors.has('Group Entity') ? 'select-required-error' : ''"
                    v-model="formDataReseller['resellerDetails']['groupEntity']"
                    :options="formGroupEntity"
                    :closeOnSelect="true"
                    :clearable="false"
                    v-validate="'required'"
                    data-vv-validate-on="change"
                    :required="!formDataReseller['resellerDetails']['groupEntity']"
                    :noDrop="(mode == 'view' && !reqType)"></v-select>

                    <span v-if="errors.has('Group Entity')" class="select-required-error--span span-text-validation"> Required field </span>
                  </div>

                  <div class="vx-col w-1/4 mt-6 px-0" v-if="!((mode == 'view' && !reqType))">
                    <vx-tooltip text="Choose from the list or add a new group entity if it’s missing" position="top">
                      <vs-button color="black" class="mt-1 add-more-btn" type="filled" icon-pack="feather" icon="icon-plus" @click="addNewGroupEntity()"></vs-button>
                    </vx-tooltip>
                  </div>
                </div>

                <div class="vx-row mt-4">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Nameservers</label>
                    <!-- <v-select
                      name="type"
                      class="w-full custom-multi-select"
                      :class="mode == 'view' ? 'unclearable' : ''"
                      v-model="formDataReseller['resellerDetails']['nameservers']"
                      :options="formNameservers"
                      :closeOnSelect="false"
                      :clearable="!mode == 'view'"
                      :multiple="true"
                      :noDrop="(mode == 'view' && !reqType)"></v-select> -->
                      <treeselect name="client" class="w-full" :class="'unclearable'" v-model="formDataReseller['resellerDetails']['nameservers']" 
                      :async="true" :load-options="nameserverList" :multiple="true" :flat="true"
                      :default-expand-level="1" :clearable="false"
                      placeholder=""
                      :disabled="(mode == 'view' && !reqType)"
                      @input="onNameServerInput"/>
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row mt-6">
                  <div class="vx-col">
                    <h5 class="tab-title">Point of Contact Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-4" v-for="(contactDetail, index) in formDataReseller['resellerDetails']['contactDetails']" :key="`ContactDetail-${index}`">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Contact {{ index + 1 }} Name {{ index == 0 ? '*' : ''}}</label>
                    <vs-input
                      class="w-full"
                      :name="`Contact Name-${index}`"
                      :key="`Contact Name-${index}`"
                      v-model="contactDetail['name']" 
                      v-validate="!index ? 'required' : ''"
                      data-vv-validate-on="change"
                      :danger="errors.has(`Contact Name-${index}`)"
                      danger-text="Required field"
                      v-bind:readonly="(mode == 'view' && !reqType)"/>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Reseller Contact {{ index + 1 }} Email {{ index == 0 ? '*' : ''}}</label>
                    <vs-input
                      class="w-full"
                      :data-vv-name="`Contact Email-`+index"
                      v-model="contactDetail['email']"
                      v-validate="!index ? 'required|email' : 'email'"
                      data-vv-validate-on="change"
                      :danger="errors.has(`Contact Email-`+index)"
                      :danger-text="errors.has(`Contact Email-`+index) ? (errors.items.find(x => x.field == `Contact Email-`+index).rule == 'required' ? 'Required field' : 'Invalid email') : ''"
                      v-bind:readonly="(mode == 'view' && !reqType)"/>
                  </div>

                  <div>
                    <vs-button
                      v-show="formDataReseller['resellerDetails']['contactDetails'].length > 1 && mode !== 'view'"
                      color="danger"
                      type="flat"
                      icon-pack="feather"
                      icon="icon-x"
                      class="mt-6"
                      @click="removeContactDetail(index)"></vs-button>
                  </div>

                  <div v-if="(index == formDataReseller['resellerDetails']['contactDetails'].length - 1) && !((mode == 'view' && !reqType))" class="vx-col w-1/4 mt-6">
                    <vs-button color="black" class="mt-1 add-more-btn" type="filled" icon-pack="feather" icon="icon-plus" @click="addContactDetails()">Add</vs-button>
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row mb-6">
                  <vs-button class="ml-auto" type="filled" icon-pack="feather" icon="icon-arrow-right" icon-after @click="nextToPayment()">Next</vs-button>
                </div>
              </div>
            </vs-tab>

            <vs-tab label="Billing & Payment" :disabled="!flags['previousTabsValid'] && !(mode == 'view' && !reqType)">
              <hr class="mt-2">

              <div class="tab-text">
                <div class="vx-row mt-8">
                  <div class="vx-col">
                    <h5 class="tab-title">Payment Details</h5>
                  </div>
                </div>

                <div class="vx-row mt-6">
                  <div class="vx-col w-1/4">
                  <label class="vs-input--label inline-flex pb-2">List Based</label>
                    <v-select
                    name="List Based"
                    class="w-full"
                    v-model="formDataReseller['paymentDetails']['listBased']"
                    :options="formBooleanValues"
                    :closeOnSelect="true"
                    :clearable="false"
                    :noDrop="(mode == 'view' && !reqType)"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <!-- <label class="vs-input--label inline-flex pb-2">List Frequency</label> -->
                    <label class="vs-input--label pb-2 flex justify-between">
                      <span>List Frequency</span>
                      <span class="mr-0">
                        <vx-tooltip text="Select NA if its not a rebate partner" position="top" class="tooltip-in-popup">
                            <i class="vs-icon notranslate icon-scale vs-button--icon feather icon-info null"></i>
                        </vx-tooltip>
                      </span>
                    </label>
                    <v-select
                    name="List Frequency"
                    class="w-full"
                    v-model="formDataReseller['paymentDetails']['listFrequency']"
                    :options="formListFrequency"
                    :closeOnSelect="true"
                    :clearable="false"
                    :noDrop="(mode == 'view' && !reqType)"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Payment Mode</label>
                    <v-select
                    name="Payment Mode"
                    class="w-full"
                    v-model="formDataReseller['paymentDetails']['paymentMode']"
                    :options="formPaymentMode"
                    :closeOnSelect="true"
                    :clearable="false"
                    :noDrop="(mode == 'view' && !reqType)"></v-select>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Custom List</label>
                    <v-select
                    name="Custom List"
                    class="w-full"
                    v-model="formDataReseller['paymentDetails']['customList']"
                    :options="formBooleanValues"
                    :closeOnSelect="true"
                    :clearable="false"
                    :noDrop="(mode == 'view' && !reqType)"></v-select>
                  </div>
                </div>

                <div class="vx-row mt-4" v-if="formDataReseller['paymentDetails']['paymentMode'] && formDataReseller['paymentDetails']['paymentMode']['value'] == 'bank'">
                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Billing Entity *</label>
                    <v-select
                    name="Billing Entity"
                    class="w-full"
                    :class="errors.has('Billing Entity') ? 'select-required-error' : ''"
                    v-model="formDataReseller['paymentDetails']['billingEntity']"
                    :options="formBillingEntity"
                    :closeOnSelect="true"
                    :clearable="false"
                    v-validate="formDataReseller['paymentDetails']['paymentMode'] && formDataReseller['paymentDetails']['paymentMode']['value'] == 'bank' ? 'required' : ''"
                    mode="eager"
                    data-vv-validate-on="change"
                    :disabled="mode == 'view'"
                    :noDrop="(mode == 'view' && !reqType)"></v-select>
                    <span v-if="errors.has('Billing Entity')" class="select-required-error--span span-text-validation"> Required field </span>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Bank</label>
                    <vs-input
                      name="Bank"
                      class="w-full"
                      v-model="formDataReseller['paymentDetails']['bank']" 
                      v-bind:readonly="(mode == 'view' && !reqType)"/>
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">Bank A/C No.</label>
                    <vs-input
                      name="Bank A/C No"
                      class="w-full"
                      v-model="formDataReseller['paymentDetails']['bankACNo']"
                      v-bind:readonly="(mode == 'view' && !reqType)" />
                  </div>

                  <div class="vx-col w-1/4">
                    <label class="vs-input--label inline-flex pb-2">SWIFT Code</label>
                    <vs-input
                      name="SWIFT Code"
                      class="w-full"
                      v-model="formDataReseller['paymentDetails']['swiftCode']"
                      v-bind:readonly="(mode == 'view' && !reqType)" />
                  </div>
                </div>

                <hr class="my-8">

                <div class="vx-row justify-end" v-if="reqType">
                  <vs-button class="mr-2 partner-req-action-btns" type="filled" icon-pack="feather" icon="icon-check" @click="saveAndapproveRequest()">Approve</vs-button>
                  <vs-button class="partner-req-action-btns" type="filled" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteRequest()">Delete</vs-button>
                </div>

                <div class="vx-row" v-else-if="!((mode == 'view' && !reqType))">
                  <vs-button :disabled="!flags['previousTabsValid']" class="ml-auto" @click="submit()" type="filled" icon-pack="feather" icon="icon-save">Update</vs-button>
                </div>
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </vs-popup>
    <!--  -->

    <!-- Group Entity Popup -->
    <vs-popup :active.sync="groupEntityPopupActive" title="" class="group-entity-popup">
      <vx-card>
        <div class="vx-row flex-wrap px-5 justify-center mt-6">
          <h2 class="text-center"> Add Group Entity </h2>
        </div>

        <div class="vx-row flex-wrap px-5 mt-6">
          <vs-input
            class="w-full mx-auto px-6"
            name="New Group Entity"
            placeholder="New Group Entity"
            v-model="newGroupEntity" />
        </div>

        <div class="vx-row mt-6">
          <vs-button class="mx-auto" type="filled" icon-pack="feather" @click="saveNewGroupEntity()">Add</vs-button>
        </div>
      </vx-card>
    </vs-popup>
    <!--  -->

    <!-- Error Prompt -->
    <custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
      <div class="con-content" slot="content">
        <p>Please solve the following errors: <br><ul class="error-body">{{  }}</ul></p>
      </div>
    </custom-prompt>
    <!--  -->
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import CustomPrompt from "@/components/CustomPrompt.vue";
import Treeselect from "@riophae/vue-treeselect";

// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';


export default {
  name: 'ViewOrEditReseller',
  components: {
    "v-select": vSelect,
    flatPickr,
    CustomPrompt,
    Treeselect
  },
  data() {
    return {
      resellerPopupActive: false,
      resellerModalHeading: 'View Reseller Details',
      formDataReseller: {
        // Reseller Details
        resellerDetails: {
          accountManager: null,
          newAccountManager: null,
          startDate: null,
          resellerShortName: null,
          country: null,
          website: null,
          groupEntity: null,
          nameservers: null,
          contactDetails: [{
            name: null,
            email: null
          }],
        },
        // Registrar Details
        registrarDetails: [{
          parentRegistrar: null,
          accountManager: null,
          country: null,
          cnicIanaIDs: [{
            cnic_id: '',
            iana_id: ''
          }],
          viewDetails: true
        }],
        // Payment Details
        paymentDetails: {
          listBased: null,
          listFrequency: null,
          paymentMode: null,
          customList: null,
          billingEntity: null,
          bank: null,
          bankACNo: null,
          swiftCode: null
        }
      },
      formInit: {
        nameServers: [],
        groupEntity: [],
        billingEntity: []
      },
      mode: null,
      reqType: null,
      configDateTimePicker: {
        maxDate: null,
        minDate: new Date(this.$moment(new Date()).subtract(9, 'months')),
        clickOpens: this.mode !== 'view',
        allowInput: this.mode !== 'view',
      },
      customPrompt: {
        activePrompt: false,
        title: null,
        buttonText: null,
        type: null,
        color: null,
        classList: null,
        accept: null
      },
      customPromptError: null,
      flags: {
        previousTabsValid: false
      },
      groupEntityPopupActive: false,
      newGroupEntity: null,
      resellerRawData: null,
      resellerId: null,
      regDetailsIndex: null,
      registrarName: null
    }
  },
  created() {
    // this.getNameservers();
    this.getGroupEntities();
    this.getBillingEntities();
  },
  mounted() {
    // TODO: Add new_reseller_id
    this.$root.$on('openResellerPopup', async (mode, reqType, id, data) => {
      this.mode = mode;
      this.reqType = reqType;
      this.resellerId = id;
      this.resellerRawData = data;
      this.registrarName = reqType ? (reqType == 'new-req' ? data.unique_registrar_name[0] : data.new_reseller.unique_registrar.name) : data.unique_registrar.name;

      this.configDateTimePicker['allowInput'] = this.mode !== 'view';
      this.configDateTimePicker['clickOpens'] = this.mode !== 'view';

      if(this.mode == 'edit') {
        this.resellerModalHeading = 'Edit Reseller Details';
      } else {
        this.resellerModalHeading = 'View Reseller Details';
        this.flags['previousTabsValid'] = true;
      }

      if(this.reqType == 'new-req') {
        this.formViewOrEditDataNewReq(data);
      } else if(this.reqType == 'edit-req') {
        this.formViewOrEditDataEditReq(data);
      } else {
        this.formViewOrEditData(data);
      }

      this.resellerPopupActive = true;
      
      setTimeout(() => {
        var ul = document.getElementsByClassName("ul-tabs")[0];
        ul.children[0].getElementsByClassName("vs-tabs--btn")[0].click();
      }, 1000)
    })
  },
  computed: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    showRegDetails() {
      return this.formDataReseller['registrarDetails'].some(x => !x['viewDetails']);
    },
    getCustomUniqueRegistrars() {
      return this.$store.getters.getCustomUniqueRegistrars;
    },
    formCustomUniqueRegs() {
      return this.$store.getters.getCustomUniqueRegistrars.map(x => {
        return {
          label: x['unique_registrar_shortname'],
          value: x['id']
        }
      });
    },
    formAMs() {
      return this.$store.getters.formAMs;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formNameservers() {
      if(this.formInit['nameServers'].length) {
        return this.formInit['nameServers'].map(x => {
          return {
            label: x['name'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    },
    formGroupEntity() {
      if(this.formInit['groupEntity'].length) {
        return this.formInit['groupEntity'].map(x => {
          return {
            label: x['name'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    },
    formBooleanValues() {
      return [{
        label: 'Yes',
        value: 'yes'
      },
      {
        label: 'No',
        value: 'no'
      }]
    },
    formListFrequency() {
      return [{
        label: 'NA',
        value: null
      },
      {
        label: 'Monthly',
        value: 'monthly'
      },
      {
        label: 'Quarterly',
        value: 'quarterly'
      }]
    },
    formPaymentMode() {
      return [{
        label: 'CNIC',
        value: 'cnic'
      },
      {
        label: 'Direct',
        value: 'bank'
      }]
    },
    formBillingEntity() {
      if(this.formInit['billingEntity'].length) {
        return this.formInit['billingEntity'].map(x => {
          return {
            label: x['name'],
            value: x['id']
          }
        })
      } else {
        return [{
          label: 'NA',
          value: null
        }];
      }
    },
    characterCount() {
      return 'Character Count: ' + (this.formDataReseller['resellerDetails']['resellerShortName'] ? this.formDataReseller['resellerDetails']['resellerShortName'].length : 0) + '/50';
    }
  },
  watch: {
    user_role() {
      return JSON.parse(localStorage.getItem("userDetails")).role;
    },
    user_id() {
      return JSON.parse(localStorage.getItem("userDetails")).id;
    },
    formGeo() {
      return this.$store.getters.formGeo;
    },
    formAMs() {
      return this.$store.getters.formAMs;
    },
    resellerPopupActive(val) { 
      if(!val) {
        this.resetForm();
      }
    }
  },
  methods: {
    nameserverList({ action, searchQuery, callback }) {
      let registrarName = this.formDataReseller.registrarDetails[0].parentRegistrar ? this.formDataReseller.registrarDetails[0].parentRegistrar.label : null;

      if(registrarName) {
        if (action === ASYNC_SEARCH) {
          this.$axiosSecure.get(`/nameservers/bi/${registrarName}/${searchQuery}`)
          .then(response => {
            let nameserverList = response.data;
  
            var transformedNameserverList = [];
  
            for (var nameserver of nameserverList) {
              var obj = {
                id: nameserver.name,
                label: nameserver.name,
                isDisabled: this.formDataReseller.resellerDetails.nameservers && this.formDataReseller.resellerDetails.nameservers.findIndex(x => x == nameserver.name) !== -1,
              }
  
              transformedNameserverList.push(obj);
            }
  
            callback(null, transformedNameserverList);
          })
          .catch(error => {
              console.log("Entity Search Error", error);
          })
        } else {
          var transformedNameserverList = [];

          for (var nameserver of this.formDataReseller.resellerDetails.nameservers) {
            var obj = {
              id: nameserver.name,
              label: nameserver.name,
            }

            transformedNameserverList.push(obj);
          }

          callback(null, transformedNameserverList);
        }
      } else {
        return [];
      }
    },
    onNameServerInput(newValue) {
      // Prevent removal of pre-populated values
      const allowedIds = this.resellerRawData.nameserver.map(o => o.nameserver);
      const missing = allowedIds.find(ns => !newValue.includes(ns));

      if (missing) {
        this.$nextTick(() => {
          this.formDataReseller.resellerDetails.nameservers = [...allowedIds];
        });
      } else {
        this.formDataReseller.resellerDetails.nameservers = newValue;
      }
    },
    // NOTE: Format data for view/edit of approved resellers
    formViewOrEditData(data) {
      // NOTE: Reseller Details
      this.formDataReseller['resellerDetails']['accountManager'] = this.formAMs.find(x => x.value == (data.new_reseller_client_am && data.new_reseller_client_am[0] && data.new_reseller_client_am[0].user ? data.new_reseller_client_am[0].user.id : null)) || { label: 'NA', value: null };
      this.formDataReseller['resellerDetails']['newAccountManager'] = this.formAMs.find(x => x.value == (data.new_reseller_client_am && data.new_reseller_client_am[0] && data.new_reseller_client_am[0].user ? data.new_reseller_client_am[0].user.id : null)) || { label: 'NA', value: null };
      this.formDataReseller['resellerDetails']['startDate'] = null;
      this.formDataReseller['resellerDetails']['resellerShortName'] = data.name;
      this.formDataReseller['resellerDetails']['country'] = this.formGeo.find(x => x.value == data.country_id);
      this.formDataReseller['resellerDetails']['website'] = data.client_detail ? data.client_detail.website : null;
      this.formDataReseller['resellerDetails']['groupEntity'] = this.formGroupEntity.find(x => x.value == data.group_entity_id);
      // this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver && data.nameserver.length ? this.formNameservers.filter(x => data.nameserver.findIndex(y => y.nameserver == x.label ) !== -1) : null;
      // this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver && data.nameserver.length ? data.nameserver.map((ns) => {
      //   return {
      //     id: ns,
      //     label: ns
      //   }
      // }) : [];
      this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver && data.nameserver.length ? data.nameserver.map(x => x.nameserver) : null;
      this.formDataReseller['resellerDetails']['contactDetails'] = data.client_detail && data.client_detail.poc_details ? data.client_detail.poc_details : [{
        name: null,
        email: null
      }]

      // NOTE: Registrar Details
      this.formDataReseller['registrarDetails'][0]['parentRegistrar'] = this.formCustomUniqueRegs.find(x => x.value == data.unique_registrar.id);
      this.formDataReseller['registrarDetails'][0]['accountManager'] = null;
      this.formDataReseller['registrarDetails'][0]['country'] = null;
      this.formDataReseller['registrarDetails'][0]['cnicIanaIDs'] = null;
      this.formDataReseller['registrarDetails'][0]['viewDetails'] = true;

      // NOTE: Payment Details
      this.formDataReseller['paymentDetails']['listBased'] = this.formBooleanValues.find(x => x.value ==(data.client_detail ? data.client_detail.list_based : null));
      this.formDataReseller['paymentDetails']['listFrequency'] = this.formListFrequency.find(x => x.value == (data.client_detail ? data.client_detail.list_frequency : null));
      this.formDataReseller['paymentDetails']['paymentMode'] = this.formPaymentMode.find(x => x.value == (data.client_detail ? data.client_detail.payment_mode : null));
      this.formDataReseller['paymentDetails']['customList'] = this.formBooleanValues.find(x => x.value == (data.client_detail ? data.client_detail.custom_list : null));
      this.formDataReseller['paymentDetails']['billingEntity'] = this.formBillingEntity.find(x => x.value == data.billing_entity_id);
      this.formDataReseller['paymentDetails']['bank'] = data.client_detail ? data.client_detail.bank : null;
      this.formDataReseller['paymentDetails']['bankACNo'] = data.client_detail ? data.client_detail.account_number : null;
      this.formDataReseller['paymentDetails']['swiftCode'] = data.client_detail ? data.client_detail.swift_code : null;
    },
    // NOTE: Format data for view/edit of reseller new requests
    formViewOrEditDataNewReq(data) {
      // NOTE: Reseller Details
      this.formDataReseller['resellerDetails']['accountManager'] = this.formAMs.find(x => x.value == (data.am && data.am.id ? data.am.id : null)) || { label: 'NA', value: null };
      this.formDataReseller['resellerDetails']['newAccountManager'] = this.formAMs.find(x => x.value == (data.am && data.am.id ? data.am.id : null)) || { label: 'NA', value: null };
      this.formDataReseller['resellerDetails']['resellerShortName'] = data.name;
      this.formDataReseller['resellerDetails']['country'] = this.formGeo.find(x => x.value == data.country_id);
      this.formDataReseller['resellerDetails']['website'] = data.website ? data.website : null;
      this.formDataReseller['resellerDetails']['groupEntity'] = this.formGroupEntity.find(x => x.value == data.group_entity_id);
      // this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver && data.nameserver.length ? this.formNameservers.filter(x => data.nameserver.findIndex(y => y.nameserver == x.label.toString()) !== -1) : null;
      // this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver && data.nameserver.length ? data.nameserver.map((ns) => {
      //   return {
      //     id: ns,
      //     label: ns
      //   }
      // }) : [];
      this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver;
      this.formDataReseller['resellerDetails']['contactDetails'] = data.poc_details ? data.poc_details : [{
        name: null,
        email: null
      }]

      // NOTE: Registrar Details
      this.formDataReseller['registrarDetails'] = [];
      data.unique_registrar_ids.map((x, index) => {
        this.formDataReseller['registrarDetails'].push({
          parentRegistrar: this.formCustomUniqueRegs.find(x => x.value == data.unique_registrar_ids[index]),
          accountManager: null,
          country: null,
          cnicIanaIDs: null,
          viewDetails: true
        })
      })

      // NOTE: Payment Details
      this.formDataReseller['paymentDetails']['listBased'] = this.formBooleanValues.find(x => x.value == data.list_based);
      this.formDataReseller['paymentDetails']['listFrequency'] = this.formListFrequency.find(x => x.value == data.list_frequency);
      this.formDataReseller['paymentDetails']['paymentMode'] = this.formPaymentMode.find(x => x.value == data.payment_mode);
      this.formDataReseller['paymentDetails']['customList'] = this.formBooleanValues.find(x => x.value == data.custom_list);
      this.formDataReseller['paymentDetails']['billingEntity'] = this.formBillingEntity.find(x => x.value == data.billing_entity_id);
      this.formDataReseller['paymentDetails']['bank'] = data.bank;
      this.formDataReseller['paymentDetails']['bankACNo'] = data.account_number;
      this.formDataReseller['paymentDetails']['swiftCode'] = data.swift_code;
    },
    // NOTE: Format data for view/edit of reseller edit requests
    formViewOrEditDataEditReq(data) {
      // NOTE: Reseller Details
      this.formDataReseller['resellerDetails']['accountManager'] = this.formAMs.find(x => x.value == (data.am && data.am.id ? data.am.id : null));
      this.formDataReseller['resellerDetails']['newAccountManager'] = this.formAMs.find(x => x.value == (data.am && data.am.id ? data.am.id : null));
      // this.formDataReseller['resellerDetails']['startDate'] = null;
      this.formDataReseller['resellerDetails']['startDate'] = data.start_date ? new Date(data.start_date) : null;
      this.formDataReseller['resellerDetails']['resellerShortName'] = data.name;
      this.formDataReseller['resellerDetails']['country'] = this.formGeo.find(x => x.value == data.country_id);
      this.formDataReseller['resellerDetails']['website'] = data.website ? data.website : null;
      this.formDataReseller['resellerDetails']['groupEntity'] = this.formGroupEntity.find(x => x.value == data.group_entity_id);
      // this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver && data.nameserver.length ? this.formNameservers.filter(x => data.nameserver.findIndex(y => y.nameserver == x.label.toString()) !== -1) : null;
      this.formDataReseller['resellerDetails']['nameservers'] = data.nameserver;
      this.formDataReseller['resellerDetails']['contactDetails'] = data.poc_details ? data.poc_details : [{
        name: null,
        email: null
      }]
      
      // NOTE: Registrar Details
      this.formDataReseller['registrarDetails'][0]['parentRegistrar'] = this.formCustomUniqueRegs.find(x => x.value == data.new_reseller.unique_registrar.id);
      this.formDataReseller['registrarDetails'][0]['accountManager'] = null;
      this.formDataReseller['registrarDetails'][0]['country'] = null;
      this.formDataReseller['registrarDetails'][0]['cnicIanaIDs'] = null;
      this.formDataReseller['registrarDetails'][0]['viewDetails'] = true;


      // NOTE: Payment Details
      this.formDataReseller['paymentDetails']['listBased'] = this.formBooleanValues.find(x => x.value == data.list_based);
      this.formDataReseller['paymentDetails']['listFrequency'] = this.formListFrequency.find(x => x.value == data.list_frequency);
      this.formDataReseller['paymentDetails']['paymentMode'] = this.formPaymentMode.find(x => x.value == data.payment_mode);
      this.formDataReseller['paymentDetails']['customList'] = this.formBooleanValues.find(x => x.value == data.custom_list);
      this.formDataReseller['paymentDetails']['billingEntity'] = this.formBillingEntity.find(x => x.value == data.billing_entity_id);
      this.formDataReseller['paymentDetails']['bank'] = data.bank;
      this.formDataReseller['paymentDetails']['bankACNo'] = data.account_number;
      this.formDataReseller['paymentDetails']['swiftCode'] = data.swift_code;
    },
    addContactDetails() {
      if(this.formDataReseller['resellerDetails']['contactDetails'].length < 3) {
        this.formDataReseller['resellerDetails']['contactDetails'].push({
          name: null,
          email: null
        });
      }
    },
    removeContactDetail(index) {
      this.formDataReseller['resellerDetails']['contactDetails'].splice(index, 1);
    },
    addNewGroupEntity() {
      this.groupEntityPopupActive = true;
    },
    saveNewGroupEntity() {
      this.groupEntityPopupActive = false;

      this.$axiosSecure
        .post('/group-entities', { name: this.newGroupEntity })
        .then((response) => {
          if(response.data.type == 'Success') {
            this.$vs.dialog({
              color: 'success',
              title: 'Success',
              text: 'Group Entity added successfully!',
              acceptText: 'Close',
              accept: () => {},
            });
          } else {
            let liStr = '';
            response.data.message.forEach((el, index) => {
              liStr += `${index+1}. ${el}<br>`
            })
            this.customPromptError = liStr;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          }
        })
        .catch((error) => {
          let liStr = '';
          error.response.data.message.forEach((el, index) => {
            liStr += `${index+1}. ${el}<br>`
          })
          this.customPromptError = liStr;
          this.customPrompt["type"] = "error";
          this.customPrompt["classList"] = "danger-prompt";
          this.customPrompt["color"] = "danger";
          this.customPrompt["activePrompt"] = true;
        })
    },
    addIANACNICIDGroup() {
      this.formDataReseller['cnic_iana_ids'].push({
        iana_id: '',
        cnic_id: ''
      });
    },
    removeIANACNICIDGroup(index) {
      this.formDataReseller['cnic_iana_ids'].splice(index, 1);
    },
    // NOTE: Move to next tab -> To Billing & Payment Details
    nextToPayment() {
      // NOTE: Validate only inputs under Reg & Res Tab on click of Next
      if(this.mode == 'view' && !this.reqType) {
          this.flags['previousTabsValid'] = true;

          setTimeout(() => {
            var ul = document.getElementsByClassName("ul-tabs")[0];
            ul.children[1].getElementsByClassName("vs-tabs--btn")[0].click();
          }, 1000)
      } else {
        let validationResults = [
          this.$validator.validate('Parent Registrar-0'),
          this.$validator.validate('Reseller Short Name'),
          this.$validator.validate('Reseller Website'),
          this.$validator.validate('Group Entity'),
          this.$validator.validate('Contact Name-0'),
          this.$validator.validate('Contact Email-0'),
        ]
  
        Promise.all(validationResults).then(async (valid) => {
          if(!valid.includes(false)) {
            this.flags['previousTabsValid'] = true;

            setTimeout(() => {
              var ul = document.getElementsByClassName("ul-tabs")[0];
              ul.children[1].getElementsByClassName("vs-tabs--btn")[0].click();
            }, 1000);
          } else {
            var errors = this.errors.collect();
          }
        })
      }
    },
    backToResellerAndRegDetails() {
      setTimeout(() => {
        var ul = document.getElementsByClassName("ul-tabs")[0];
        ul.children[0].getElementsByClassName("vs-tabs--btn")[0].click();
      }, 1000)
    },
    setAllToView(setIndex) {
      this.formDataReseller['registrarDetails'].map((x, index) => {
        if(index !== setIndex) {
          x['viewDetails'] = true;
        }
      })

      this.regDetailsIndex = null;
      // this.getNameservers();
    },
    toggleViewDetails(index) {
      this.setAllToView(index);
      let customUniqueReg = this.getCustomUniqueRegistrars.find(x => x.id == this.formDataReseller['registrarDetails'][index]['parentRegistrar'].value);
      this.regDetailsIndex = index;
      this.formDataReseller['registrarDetails'][index]['viewDetails'] = !this.formDataReseller['registrarDetails'][index]['viewDetails'];
      this.formDataReseller['registrarDetails'][index]['accountManager'] = customUniqueReg.unique_registrar_am;
      this.formDataReseller['registrarDetails'][index]['country'] = customUniqueReg.unique_registrar_country_name;
      this.formDataReseller['registrarDetails'][index]['cnicIanaIDs'] = (customUniqueReg.cnic_id || customUniqueReg.iana_id) ? (customUniqueReg.cnic_id ? customUniqueReg.cnic_id.split(',').map((x, index) => {
        return {
          cnic_id: x,
          iana_id: customUniqueReg.iana_id ? customUniqueReg.iana_id.split(',')[index] : null
        }
      }) : customUniqueReg.iana_id.split(',').map((x, index) => {
        return {
          cnic_id: customUniqueReg.cnic_id ? customUniqueReg.cnic_id.split(',')[index] : null,
          iana_id: x
        }
      })) :
      [{
        cnic_id: null,
        iana_id: null
      }]
    },
    async getNameservers() {
      let nameservers = await this.$axiosSecure.get(`/nameservers/bi/${this.registrarName}`);
      this.formInit['nameServers'] = nameservers.data;
    },
    async getGroupEntities() {
      let groupEntities = await this.$axiosSecure.get('/group-entities');
      this.formInit['groupEntity'] = groupEntities.data;
    },
    async getBillingEntities() {
      let billingEntities = await this.$axiosSecure.get('/billing-entities');
      this.formInit['billingEntity'] = billingEntities.data;
    },
    formPayload() {
      return {
        // NOTE: Unique Reg IDs & Name only for new request as they're editable only in New Req
        unique_registrar_id: this.reqType && this.reqType == 'new-req' ? this.resellerRawData.unique_registrar_ids : undefined,
        unique_registrar_name: this.reqType && this.reqType == 'new-req' ? this.resellerRawData.unique_registrar_name : undefined,
        new_reseller_id: this.reqType ? (this.reqType == 'edit-req' ? this.resellerRawData.new_reseller_id : undefined ) : this.resellerId,
        name: this.formDataReseller['resellerDetails']['resellerShortName'],
        am_id: this.formDataReseller['resellerDetails']['accountManager'] ? this.formDataReseller['resellerDetails']['newAccountManager']['value'] : null,
        start_date: this.formDataReseller['resellerDetails']['startDate'],
        country_id: this.formDataReseller['resellerDetails']['country'] ? this.formDataReseller['resellerDetails']['country']['value'] : null,
        website: this.formDataReseller['resellerDetails']['website'],
        group_entity_id: this.formDataReseller['resellerDetails']['groupEntity'].value,
        billing_entity_id: this.formDataReseller['paymentDetails']['billingEntity'] ? this.formDataReseller['paymentDetails']['billingEntity'].value : null,
        payment_mode: this.formDataReseller['paymentDetails']['paymentMode'] ? this.formDataReseller['paymentDetails']['paymentMode'].value : null,
        list_based: this.formDataReseller['paymentDetails']['listBased'] ? this.formDataReseller['paymentDetails']['listBased'].value : null,
        list_frequency: this.formDataReseller['paymentDetails']['listFrequency'] ? this.formDataReseller['paymentDetails']['listFrequency'].value : null,
        custom_list: this.formDataReseller['paymentDetails']['customList'] ? this.formDataReseller['paymentDetails']['customList'].value : null,
        bank: this.formDataReseller['paymentDetails']['bank'],
        account_number: this.formDataReseller['paymentDetails']['bankACNo'],
        swift_code: this.formDataReseller['paymentDetails']['swiftCode'],
        nameserver : this.formDataReseller['resellerDetails']['nameservers'] ? (this.formDataReseller['resellerDetails']['nameservers'].length && this.formDataReseller['resellerDetails']['nameservers'][0] !== null ? this.formDataReseller['resellerDetails']['nameservers'].map(x => x) : null) : [],
        poc_details: this.formDataReseller['resellerDetails']['contactDetails'].filter(x => x.name && x.email) ? this.formDataReseller['resellerDetails']['contactDetails'].filter(x => x.name && x.email) : [],
      }
    },
    async submit() {
      this.$validator.validate().then(async (valid) => {
        if(valid) {
          let payload = await this.formPayload();

          await this.$axiosSecure
            .post('/new-resellers/edit', payload)
            .then((response) => {
              if(response.data.type == 'Success') {
                this.resellerPopupActive = false;

                this.$vs.dialog({
                  color: 'success',
                  title: 'Success',
                  text: 'Reseller updates have been sent for approval',
                  acceptText: 'Close',
                  accept: () => {},
                });

                // NOTE: Reset Form validation after submit
                this.$validator.pause()
                this.$nextTick(() => {
                  this.$validator.errors.clear();
                  this.$validator.fields.items.forEach(field => field.reset());
                  this.$validator.fields.items.forEach(field => this.errors.remove(field));
                  this.$validator.resume();
                })
              } else {
                let liStr = '';
                response.data.message.forEach((el, index) => {
                  liStr += `${index+1}. ${el}<br>`
                })
                this.customPromptError = liStr;
                this.customPrompt["type"] = "error";
                this.customPrompt["classList"] = "danger-prompt";
                this.customPrompt["color"] = "danger";
                this.customPrompt["activePrompt"] = true;
              }
            })
            .catch((error) => {
              let liStr = '';
              error.response.data.message.forEach((el, index) => {
                liStr += `${index+1}. ${el}`
              })
              this.customPromptError = liStr;
              this.customPrompt["type"] = "error";
              this.customPrompt["classList"] = "danger-prompt";
              this.customPrompt["color"] = "danger";
              this.customPrompt["activePrompt"] = true;
          })
        } else {
          var errors = this.errors.collect();
        }
      })
    },
    async saveAndapproveRequest() {
      this.$validator.validate().then(async (valid) => {
        if(valid) {
          let payload = await this.formPayload();
          payload['id'] = this.resellerId;

          let url = this.reqType ? (this.reqType == 'new-req' ? '/new-resellers/request/approve' : '/new-resellers/edit/approve') : '';

          await this.$axiosSecure
          .post(url, payload)
          .then((response) => {
             if(response.data.type == 'Success') {
               this.resellerPopupActive = false;

               if(this.reqType) {
                if(this.reqType == 'new-req') {
                 this.$root.$emit('refreshResellerNewReqList');
                } else {
                 this.$root.$emit('refreshResellerEditReqList');
                }
               } else {
                 this.$root.$emit('refreshResellerList');
               }
                
                this.$vs.dialog({
                  color: 'success',
                  title: 'Success',
                  text: 'Reseller saved & approved successfully!',
                  acceptText: 'Close',
                  accept: () => {},
                });

                // NOTE: Reset Form validation after submit
                this.$validator.pause()
                this.$nextTick(() => {
                  this.$validator.errors.clear();
                  this.$validator.fields.items.forEach(field => field.reset());
                  this.$validator.fields.items.forEach(field => this.errors.remove(field));
                  this.$validator.resume();
                })
              } else {
                let liStr = '';
                response.data.message.forEach((el, index) => {
                  liStr += `${index+1}. ${el}<br>`
                })
                this.customPromptError = liStr;
                this.customPrompt["type"] = "error";
                this.customPrompt["classList"] = "danger-prompt";
                this.customPrompt["color"] = "danger";
                this.customPrompt["activePrompt"] = true;
              }
          })
          .catch((error) => {
            console.log('error :>> ', error);
            let liStr = '';
            error.response.data.message.forEach((el, index) => {
              liStr += `${index+1}. ${el}`
            })
            this.customPromptError = liStr;
            this.customPrompt["type"] = "error";
            this.customPrompt["classList"] = "danger-prompt";
            this.customPrompt["color"] = "danger";
            this.customPrompt["activePrompt"] = true;
          })
        } else {
          var errors = this.errors.collect();
        }
      })
    },
    openConfirm() {
      // Open confirm popup
      this.$vs.dialog({
          type: "confirm",
          color: "danger",
          title: "Confirm",
          text: "Are you sure you want to delete the selected request?",
          acceptText: "Delete",
          cancelText: "Go Back",
          accept: () => {
            this.deleteRequest();
          },
          cancel: () => {},
      });
    },
    deleteRequest() {
      this.$axiosSecure
      .post('/new-resellers/edit/delete', { id: this.resellerId })
      .then((response) => {
          if(response.data.type == 'Success') {
            this.resellerPopupActive = false;

              this.$vs.dialog({
                  color: 'success',
                  title: 'Success',
                  text: this.reqType == 'new-request' ? 'New Reseller request deleted' : 'Edit Reseller request deleted',
                  acceptText: 'Close',
                  accept: () => {},
              });
          } else {
              this.$vs.notify({
                  color: "danger",
                  title: "Something went wrong",
                  text: "Please contact the server admin",
              });
          }
      })
      .catch((error) => {
          this.$vs.notify({
              color: "danger",
              title: "Something went wrong",
              text: "Please contact the server admin",
          });
      })
    },
    resetForm() {
      this.flags['previousTabsValid'] = false;
      this.formDataReseller = {
        // Reseller Details
        resellerDetails: {
          accountManager: null,
          resellerShortName: null,
          newAccountManager: null,
          startDate: null,
          country: null,
          website: null,
          groupEntity: null,
          nameservers: null,
          contactDetails: [{
            name: null,
            email: null
          }],
        },
        // Registrar Details
        registrarDetails: [{
          parentRegistrar: null,
          accountManager: null,
          country: null,
          cnicIanaIDs: [{
            cnic_id: '',
            iana_id: ''
          }],
          viewDetails: true
        }],
        // Payment Details
        paymentDetails: {
          listBased: null,
          listFrequency: null,
          paymentMode: null,
          customList: null,
          billingEntity: null,
          bank: null,
          bankACNo: null,
          swiftCode: null
        }
      }
      this.backToResellerAndRegDetails();
    },
  },
  destroyed() {
    this.$root.$off('openResellerPopup');
  }
}
</script>